var site = site || {};

site.customerServiceContact = site.customerServiceContact || (function ($) {
  var $contactForm;

  function initializeValues() {
    $contactForm = $('.customer-service-contact-form');
    $contactFormErrors = $('.customer-service-contact-form__errors');
  }

  function bindEvents() {
    // When a menu link is clicked, toggle its submenu.
    $('.customer-service-menu .menu__link--lvl-1').on('click', toggleSubmenu);
    // Show the correct radio button list when a category is clicked.
    $('.customer-service-contact-form__category').on('click', toggleCategory);
    // Form submission
    $contactForm.on('submit', submitContactForm);
  }

  // Hide the quick info block for email contact us page.
  function hideItems() {
    $('.customer-service-quick-info').hide();
    $('#contact-thanks').hide();
    $('#contact-thanks-content').hide();
  }

  // Make the default category active on page load.
  function activateDefaultCategory() {
    $('#category-online').addClass('active-category');
    $('#category-online-content').show();
  }

  // When a menu topic is clicked, reveal (or hide) the submenu.
  function toggleSubmenu() {
    $(this).parent().toggleClass('active-submenu');
    $(this).attr('aria-expanded', $(this).parent().hasClass('active-submenu'));
  }

  // When a category is clicked in the contact form, show its radio button list.
  function toggleCategory() {
    var categoryContentID = '#' + $(this).attr('id') + '-content';

    $('.customer-service-contact-form__category').removeClass('active-category'); // Reset all category buttons.
    $(this).addClass('active-category'); // Make the active category button pink.
    $('.customer-service-contact-form__category-content').hide(); // Hide all category content.
    $(categoryContentID).show(); // Show the active category content.
  }

  function submitContactForm(event) {
    event.preventDefault();

    // Reset all input fields display.
    $('input', $contactForm).removeClass('error');

    // Loading Button
    var enableLoading = $('.js-loading-message', $contactForm).length > 0;
    var $btnElements = $('.js-loading-message, .js-contact-submit', $contactForm);

    if (enableLoading) {
      $btnElements.toggleClass('hidden');
    }

    // Put the form values into an object.
    var parametersArray = $contactForm.serializeArray();
    var parametersObject = {};

    $.each(parametersArray, function (index, param) {
      parametersObject[param.name] = param.value;
    });

    generic.jsonrpc.fetch({
      method: 'rpc.form',
      params: [parametersObject],
      onSuccess: function (jsonRpcResponse) {
        $contactFormErrors.hide();
        $('#contact-thanks').attr({
          'tabindex': '-1',
          'aria-label': $('#contact-thanks').text()
        }).show();
        $('#contact-thanks-content').show();
        $('#contact-send').hide();
        $('#contact-send-content').hide();
        $('#contact-about').hide();
        $('#contact-about-content').hide();
        var thxpos = $('#contact-thanks-content').position();

        $('html, body').animate({
          scrollTop: thxpos
        }, 800);
        $('#contact-thanks').focus();
      },
      onFailure: function (jsonRpcResponse) {
        if (enableLoading) {
          $btnElements.toggleClass('hidden');
        }
        // Get errors back and build a set of list items to inject into the HTML.
        var errorObjectsArray = jsonRpcResponse.getMessages();
        var ordering = [
          'required.first_name.contact_us',
          'required.last_name.contact_us',
          'required.email_address.contact_us',
          'required.email_address2.contact_us'
        ];

        generic.errorOrder(errorObjectsArray, $contactFormErrors, ordering, $contactForm);
        // Scroll the page to top of error list node adjusting for the nav.
        var errorsPostion = $contactFormErrors.position();
        var scrollTop = errorsPostion && errorsPostion.top ? errorsPostion.top + $('.site-header').height() : '';

        $('html, body').animate({
          scrollTop: scrollTop
        }, 800);
        generic.focusErrors($('.customer-service-contact-form__errors'), $('.active-subsection'));
      }
    });
  }

  return {
    init: function () {
      initializeValues();
      hideItems();
      activateDefaultCategory();
      bindEvents();
    }
  };
})(jQuery);

(function ($) {
  Drupal.behaviors.customerServiceContactV1 = {
    attach: function (context, settings) {
      site.customerServiceContact.init();
    }
  };
})(jQuery);
